<template>
<div id="tongji">
	<div class="leftBox" v-loading='uinfo_load'>
		<div class="ulogoBox" :text="ulogo">
			<el-image :src="ulogo">
				<div slot="error" class="image-slot">
					<el-image :src="defaUlogo"></el-image>
				</div>
			</el-image>
		</div>
		<div class="uinfo">
			<div class="uname">
				<h2>{{uname}}</h2>
				<p class="school">{{school}}</p>
				<p class="zy">{{zhuanye}}<span>（{{cengci}}）</span></p>
			</div>
			<div class="ustudy">
				<h2>学习进度</h2>
				<div class="courseSt">
					<div class="cou zong"><p>总课程数</p><h3><font>{{mould_course_count}}</font>门</h3></div>
					<div v-if="hideType === 3" class="cou guo"><p>已通过课程数</p><h3><font>{{course_progress}}</font>门</h3></div>
				</div>
			</div>
		</div>
	</div>
	<div class="tongjiBox">
		<div class="titBox">
			<p class="tit">学习统计</p>
		</div>
		<div class="tongjiCon" v-loading="loading">
			<ul class="jindu">
				<li v-for="(item, key, index) in wanList" v-if="key!='homework' && key!='test'" :key="index" :class="progressClass(item.finish, item.total)">
					<i class="iconfont" v-html="item.icon"></i>
					<div class="jinduInfo">
						<p class="duNum"><font>{{item.finish}}</font>个</p>
						<p class="duTit">{{item.title}}</p>
					</div>
				</li>
			</ul>
			<dl class="qita" v-show="false">
				<dd v-for="(item,index) in qita" :key="index">
					<h3>{{item.title}}</h3>
					<p class="con">{{qitaConFn(item.type, item.data, item.unit)}}</p>
				</dd>
			</dl>
		</div>
	</div>
</div>
</template>

<script>

export default {
	name: 'tongji'
	,data () {
		return {
			defaUlogo:''
			,loading:true

			// //用户数据
			,ulogo:''
			,uinfo_load:true
			,uname:"姓名"
			,school:"学校"
			,zhuanye:"专业"
			,cengci:"层次"
			,course_progress:0
			,mould_course_count:0

			//视频进度
			,wanList:{}

			//其它统计
			,qita:{
				"xuexi":{
					title:"在线学习总时长"
					,type:"time"
					,data:128880
					,unit:""
				},
				"qiandao":{
					title:"签到次数"
					,type:"number"
					,data:0
					,unit:"次"
				},
				"biji":{
					title:"笔记数"
					,type:"number"
					,data:0
					,unit:"个"
				},
				"taolun":{
					title:"讨论数"
					,type:"number"
					,data:0
					,unit:"个"
				},
			}
		}
	}
	,mounted:function(){
		var that = this
		this.defaUlogo = this.global.oss_website+'/pc/images/ulogo.jpg';

		this.global.uDetailData = {}
		this.$selfjs.getUserCallFn(that, function(res){
			that.uinfo_load=false
			
			that.ulogo=res.avatar						//用户头像
			that.uname=res.nick_name					//用户名
			that.school=res.school.school_name			//学校名称
			that.zhuanye=res.major.major_name			//专业名称
			that.cengci=that.$store.state.const.major_level.find(v=>{ return v.id == res.major.major_level}).value		//层级
			that.course_progress=res.course_progress				//课程进度
			that.mould_course_count=res.mould_course_count			//课程总数


			var token=that.$cookies.get("token")
				
			//获取学习统计
			const url = that.global.serverSrc+that.global.qianzui+'/member/learnProgress';
			that.$ajax.get(url)
			.then(function(res){
				let resData=res.data;
				if(resData.code==0){
					that.wanList = resData.data;
					let learnProgress = resData.data;
					for(let key in learnProgress){
						that.wanList[key] = learnProgress[key]
						let titCon = ''
							,icon
						switch (key){
							case "video":
								titCon = '已观看视频'
								icon = '&#xe621;'
								break;
							case "test":
								titCon = '已发表讨论'
								icon = ''
								break;
							case "homework":
								titCon = '已完成笔记'
								icon = ''
								break;
							case "exam":
								titCon = '已学习课件'
								icon = '&#xe61d;'
								break;
							case "discuss":
								titCon = '已发表讨论'
								icon = '&#xe640;'
								break;
							case "notes":
								titCon = '已完成笔记'
								icon = '&#xe692;'
								break;
						}
						that.wanList[key].title = titCon
						that.wanList[key].icon = icon
					}
					console.log(that.wanList);
				}else if(resData.code==401){
					that.$message.error('请求错误，请重新登录');
					that.$selfjs.loginOutFn(that, "route")
				}else{
					that.$message.error('Σ(⊙▽⊙"a您所请求的服务器，目前正在外太空漂流~~~');
				}
				that.loading = false
			})
		})
	}
	,methods:{
		//其它统计文字输出
		qitaConFn(type, data, unit){
			if(type=="number"){
				return data + unit
			}else if(type=="time"){
				var day = Math.floor( data/ (24*3600) ); // Math.floor()向下取整 
				var hour = Math.floor( (data - day*24*3600) / 3600); 
				var minute = Math.floor( (data - day*24*3600 - hour*3600) /60 ); 
				var second = data - day*24*3600 - hour*3600 - minute*60; 
				return day + "天"  + hour + "时" + minute + "分" + second + "秒";
			}
		},
		//进度条颜色
		progressColor(start, end){
			let color="#ddd"
				,biPosition = parseInt((start/end)*100);
			if(biPosition>=1 && biPosition<=10){
				color="#ddd"
			}else if(biPosition>=11 && biPosition<=33){
				color="#ed5565"
			}else if(biPosition>=34 && biPosition<=66){
				color="#ff9900"
			}else if(biPosition>=67 && biPosition<=100){
				color="#67c23a"
			}
			return color
		},
		//进度条样式
		progressClass(start, end){
			let className="wu"
				,biPosition = parseInt((start/end)*100);
			if(biPosition>=1 && biPosition<=10){
				className="wu"
			}else if(biPosition>=11 && biPosition<=33){
				className="di"
			}else if(biPosition>=34 && biPosition<=66){
				className="zhong"
			}else if(biPosition>=67 && biPosition<=100){
				className="gao"
			}
			return className
		},
		//课程进度计算
		classChapter(start, end){
			if(start == 0){
				return 0;
			}else{
				return parseInt((start/end)*100)
			}
		}
	}
	,computed:{
		//根据身份隐藏内容
		hideType(){
			return parseInt(this.$store.state.hideType)
		},
	}
}
</script>
<!-- scoped单页面有效属性 -->

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/tongji.vue